// extracted by mini-css-extract-plugin
export var brand = "_bq-9";
export var compact = "_bq-6";
export var extraSmall = "_bq-7";
export var icon = "_bq-0";
export var large = "_bq-4";
export var light = "_bq-1";
export var medium = "_bq-5";
export var outline = "_bq-b";
export var primaryDark = "_bq-a";
export var primaryLight = "_bq-8";
export var primaryModern = "_bq-c";
export var success = "_bq-2";
export var successSolid = "_bq-3";